import { render } from "./car1.vue?vue&type=template&id=4c99bd5b&scoped=true"
const script = {}

import "./car1.vue?vue&type=style&index=0&id=4c99bd5b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c99bd5b"]])

export default __exports__